<script setup lang="ts">
    import type { Column } from '@tanstack/vue-table';
    import { ArrowDown, ArrowUp, ChevronsUpDown } from 'lucide-vue-next';

    import { Button } from '@/components/ui/button';

    interface DataTableSortButtonProps {
        column: Column<any, any>;
        title: string;
        tableHasSelectedRows?: boolean;
    }

    const props = defineProps<DataTableSortButtonProps>();
</script>

<template>
    <Button
        variant="ghost_primary"
        size="sm"
        class="data-[state=open]:bg-accent h-8 justify-start gap-0.5 px-0! text-xs font-semibold normal-case"
        :class="{ 'opacity-50': tableHasSelectedRows }"
        @click="column.toggleSorting(column.getIsSorted() === 'asc')"
    >
        <span>{{ title }}</span>
        <ArrowDown
            v-if="column.getIsSorted() === 'desc'"
            class="size-3.5"
        />
        <ArrowUp
            v-else-if="column.getIsSorted() === 'asc'"
            class="size-3.5"
        />
        <ChevronsUpDown
            v-else
            class="size-3.5"
        />
    </Button>
</template>
